/**
 * composite-images 接口里，键可能为：
 * - 当前保存格式：`${templateId}-${imageId}-${groupIndex}`（见 FundingTools 合成图持久化）
 * - 历史格式：`${templateId}-${groupIndex}`（仅两段，且末段为数字）
 */
export function matchGoodsCompositeMapKey(key, templateId) {
  const tid = String(templateId ?? '');
  const raw = String(key ?? '');
  if (!tid || !raw) return { ok: false, groupIndexFromKey: null };
  const prefix = `${tid}-`;
  if (!raw.startsWith(prefix)) return { ok: false, groupIndexFromKey: null };
  const suffix = raw.slice(prefix.length);
  if (suffix === '') return { ok: false, groupIndexFromKey: null };
  const li = suffix.lastIndexOf('-');
  if (li === -1) {
    const g = Number.parseInt(suffix, 10);
    return Number.isNaN(g) ? { ok: false, groupIndexFromKey: null } : { ok: true, groupIndexFromKey: g };
  }
  const groupPart = suffix.slice(li + 1);
  if (!/^\d+$/.test(groupPart)) return { ok: false, groupIndexFromKey: null };
  const g = Number.parseInt(groupPart, 10);
  return Number.isNaN(g) ? { ok: false, groupIndexFromKey: null } : { ok: true, groupIndexFromKey: g };
}
